const messages = {
  title: "Vouchers",
  short_description:
    "Vous y trouverez la liste de vos bons d'achat. Vous pouvez les partager avec vos clients. Les bons d'achat sont à usage unique.",
  table: {
    headers: {
      voucher: "Voucher codes",
      company: "Company",
      street: "Street",
      postcode: "Postcode",
      location: "Location",
      solved_at: "Date",
      points: "Number of points via the code",
    },
  },
  exchange: {
    title: "Enter your code to get points",
    pointsLabel: "Enter the code here:",
    result: "Number of points:",
  },
};

export default {
  messages,
};
